import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"

export const ErrorImg = styled.img`
  width: 100px;
  height: 100px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    width: auto;
    height: auto;
  `}
`

export const ErrorWrapper = styled(Flex)`
  text-align: center;
  padding-top: 30px;

  > * {
    margin-bottom: 25px;
    &:last-child {
      margin-top: 15px;
    }
  }

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    padding-top: 60px;

    > * {
      margin-bottom: 30px;
    }
  `}
`
